import { getMessage } from '@/utils/messages'

export function Footer() {
  return (
    <footer className="w-full mt-auto border-t border-[var(--border)] bg-[var(--surface)]">
      <p className="text-center text-[11px] text-[var(--text-muted)] py-3 tracking-[0.2px]">
        {getMessage('footer.copyright')}
      </p>
    </footer>
  )
}